const loginRedirect = () => {
  window.location.assign("/login");
  throw new Error("login redirect");
};

const validateSessionUser = data => {
  if (typeof data !== "object") return new Error("not an object");
  if (data === null) return new Error("null");

  if (!("email" in data)) return new Error("missing email");
  const email = data.email;
  if (typeof email !== "string") return new Error("email is not a string");

  if (!("organizationId" in data)) return new Error("missing organizationId");
  const organizationId = data.organizationId;
  if (typeof organizationId !== "number")
    return new Error("organizationId is not a number");

  if (!("serviceAreaId" in data)) return new Error("missing serviceAreaId");
  const serviceAreaId = data.serviceAreaId;
  if (typeof serviceAreaId !== "number")
    return new Error("serviceAreaId is not a number");

  const result = {
    email,
    organizationId,
    serviceAreaId,
  };

  return result;
};

const validateSession = data => {
  if (typeof data !== "object") throw new Error("not an object");
  if (data === null) throw new Error("null");

  if (!("user" in data)) return new Error("missing serviceAreaId");
  const user = validateSessionUser(data.user);
  if (user instanceof Error) return user;

  const result = {
    user,
  };

  return result;
};

export const getSession = () => {
  const parts = document.cookie.split(";");

  const jwt = parts.find(cookie => cookie.includes("jwt-valet"));
  if (typeof jwt === "undefined") {
    loginRedirect();
    throw new Error("jwt-valet cookie is undefined");
  }

  const payload = jwt.split(".")[1];
  if (typeof payload === "undefined")
    throw new Error("can't parse jwt payload");

  const session = JSON.parse(atob(payload));

  const result = validateSession(session);
  if (result instanceof Error) {
    // TODO: message error
    throw result;
  }

  return result;
};
